// SECTION 1
gsap.set(".co-services-1", { opacity: 0, transition: 0 });
gsap.to(".co-services-1", { 
    opacity: 1,
    duration: 1
});
document.addEventListener("DOMContentLoaded", function (event) {
  window.requestAnimationFrame(function () {
    // SECTION 2
    gsap.set(".co-services-2", { opacity: 0, transition: 0 });
    gsap.to(".co-services-2", { 
        opacity: 1,
        duration: 1
    });
    gsap.to(".co-services-2-right img", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-services-2",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -50
    });
    // SECTION 3
    gsap.to(".co-services-3-item", {
      scrollTrigger: {
        trigger: ".co-services-3-item",
        start: "15% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      stagger: 0.15
    });
    // *
    gsap.to(".co-services-4-frame>svg", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-services-4",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: 7
    });
    // *
    gsap.to(".co-services-4-ani>*", {
      scrollTrigger: {
        trigger: ".co-services-4-content",
        start: "15% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      stagger: 0.15
    });
    // *
    gsap.to(".co-services-5", {
      scrollTrigger: {
        trigger: ".co-services-5",
        start: "0% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
    });
    gsap.to(".co-services-5-right-frame img", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-services-5-right-frame",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -5
    });

  });
});
// COMPARISON
(function() {
  function initSliders() {
    var section = document.getElementById('co-comparison-standalone-id');
    if (!section) return;

    section.querySelectorAll('[data-comparison-standalone]').forEach(function(el) {
      var overlay = el.querySelector('.image-compare-overlay');
      var slider = el.querySelector('.image-compare-slider');
      var overlayImg = overlay.querySelector('img');
      var isResizing = false;
      var currentPct = 50;

      function updateDimensions() {
        var w = el.offsetWidth + 'px';
        if (overlayImg) overlayImg.style.width = w;
        var wrapper = overlay.firstElementChild;
        if (wrapper) wrapper.style.width = w;
      }

      function setPosition(pct) {
        currentPct = Math.max(0, Math.min(pct, 100));
        overlay.style.width = currentPct + '%';
        slider.style.left = currentPct + '%';
        el.setAttribute('aria-valuenow', Math.round(currentPct));
        el.setAttribute('aria-valuetext', Math.round(currentPct) + ' percent, showing ' + Math.round(currentPct) + '% before and ' + Math.round(100 - currentPct) + '% after');
      }

      function updateFromPointer(x) {
        var rect = el.getBoundingClientRect();
        var position = Math.max(0, Math.min(x - rect.left, rect.width));
        setPosition((position / rect.width) * 100);
      }

      function startResize(e) {
        e.preventDefault();
        isResizing = true;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        updateFromPointer(x);

        var move = function(e) {
          if (!isResizing) return;
          updateFromPointer(e.touches ? e.touches[0].clientX : e.clientX);
        };
        var end = function() {
          isResizing = false;
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', end);
          document.removeEventListener('touchmove', move);
          document.removeEventListener('touchend', end);
        };

        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', end);
        document.addEventListener('touchmove', move);
        document.addEventListener('touchend', end);
      }

      el.addEventListener('keydown', function(e) {
        var step = e.shiftKey ? 10 : 2;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            e.preventDefault();
            setPosition(currentPct - step);
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            e.preventDefault();
            setPosition(currentPct + step);
            break;
          case 'Home':
            e.preventDefault();
            setPosition(0);
            break;
          case 'End':
            e.preventDefault();
            setPosition(100);
            break;
        }
      });

      updateDimensions();
      el.addEventListener('mousedown', startResize);
      el.addEventListener('touchstart', startResize);
      window.addEventListener('resize', updateDimensions);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();
// COMPARISON
gsap.to(".co-plp-s2-drop-left", {
  scrollTrigger: {
    trigger: ".co-comparison-standalone",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  top: "-30%",
});
gsap.to(".co-plp-s2-drop-right", {
  scrollTrigger: {
    trigger: ".co-comparison-standalone",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  bottom: "-50%",
});